// extracted by mini-css-extract-plugin
export default {"container":"Jn-z","bubbleNav":"Kn-z","graphic":"Ln-z","contact":"Mn-z"};